import {
  SET_PAGE,
  SET_START,
  SET_SORT,
  SET_FILTER,
  SET_STATUS,
  RESET_SEARCH_PARAMS,
  ListingSearchState,
  ListingSearchActionTypes,
  SET_HEADER_SEARCH,
} from './types';

const initialState: ListingSearchState = {
  query: '',
  page: 1,
  start: 0,
  size: 100,
  sort: null,
  filter: null,
  status: null,
  search: null,
};

export default function listingsSearchParamsReducer(
  state = initialState,
  action: ListingSearchActionTypes
): ListingSearchState {
  switch (action.type) {
    case SET_PAGE: {
      const { page } = action;
      return {
        ...state,
        page,
      };
    }
    case SET_START: {
      const { start } = action;
      return {
        ...state,
        start,
      };
    }
    case SET_SORT: {
      const { sort } = action;
      return {
        ...state,
        sort,
      };
    }
    case SET_STATUS: {
      const { status } = action;
      return {
        ...state,
        status,
      };
    }
    case SET_FILTER: {
      const { filter } = action;
      return {
        ...state,
        start: initialState.start,
        page: initialState.page,
        filter,
      };
    }
    case SET_HEADER_SEARCH: {
      const { search } = action;
      return {
        ...state,
        search,
      };
    }
    case RESET_SEARCH_PARAMS: {
      return {
        ...state,
        page: initialState.page,
        start: initialState.start,
        sort: null,
        filter: null,
        search: null,
      };
    }
    default:
      return state;
  }
}
